// use history from react-router-dom
// eslint-disable-next-line import/no-extraneous-dependencies
import {
  IframeQueryParameters,
  RouterOptions,
  toStringEnum,
} from '@wix/wix-chatbot-common/browser';
import { createPath, parsePath } from 'history';

import { assertUnreachable, getLast } from '../util/guards';
import { getRouterBaseName } from './baseName';
import { trimBaseName } from './trimBaseName';

// TODO:homepage it will not be needed after merge 'specs.engage.enableHomepage'
export function applyUrlToNavigationHistory(
  navigationHistory: string[],
  url = new URL(window.location.href),
) {
  const routerOptions = toStringEnum(
    RouterOptions,
    url.searchParams.get(IframeQueryParameters.applyUrlToRouter),
  );

  if (routerOptions === undefined) {
    return;
  }

  switch (routerOptions) {
    case RouterOptions.NewRoute:
      const lastHistoryItem = getLast(navigationHistory);
      // we need to remove basename before using it in Router
      const routeWithoutBaseName = trimBaseName(
        getRouterBaseName(url.pathname),
        createPath(url),
      );

      if (routeWithoutBaseName !== lastHistoryItem) {
        navigationHistory.push(routeWithoutBaseName);
      }
      break;
    case RouterOptions.ModifyRouteParams:
      const parsedLastRoute = parsePath(navigationHistory.pop() ?? '/');
      const modifiedSearchParams = new URLSearchParams(parsedLastRoute.search);

      url.searchParams.forEach((value, key) =>
        modifiedSearchParams.set(key, value),
      );
      parsedLastRoute.search = modifiedSearchParams.toString();

      navigationHistory.push(createPath(parsedLastRoute));
      break;
    default:
      assertUnreachable(routerOptions);
  }
}
